export const Sizes = ['XS', 'S', 'M', 'L', 'XL'];

export const MeasurementSystem = {
  metric: {
    id: 'metric',
    unit: 'interactiveSizeGuide.measureSystem.centimeters',
    abbrev: 'interactiveSizeGuide.measureSystem.centimeters.abbrev',
    sizes: {
      waist: [68, 72, 76, 80, 84],
      hips: [94, 98, 102, 106, 110],
      bust: [84, 88, 92, 96, 100],
    },
  },
  imperial: {
    id: 'imperial',
    unit: 'interactiveSizeGuide.measureSystem.inches',
    abbrev: 'interactiveSizeGuide.measureSystem.inches.abbrev',
    sizes: {
      waist: [27, 28, 30, 31, 33],
      hips: [37, 39, 40, 42, 43],
      bust: [33, 35, 36, 38, 39],
    },
  },
};

const RegionId = {
  UK: 'UK',
  EU: 'EU',
  USandCA: 'USandCA',
};

export const CountryToRegionMap = {
  eu: RegionId.EU,
  uk: RegionId.UK,
  us: RegionId.USandCA,
  ca: RegionId.USandCA,
};

export const Regions = [
  {
    id: RegionId.UK,
    name: 'interactiveSizeGuide.region.UK',
    sizes: [8, 10, 12, 14, 16],
    measurementSystem: MeasurementSystem.imperial.id,
  },
  {
    id: RegionId.EU,
    name: 'interactiveSizeGuide.region.EU',
    sizes: [36, 38, 40, 42, 44],
    measurementSystem: MeasurementSystem.metric.id,
  },
  {
    id: RegionId.USandCA,
    name: 'interactiveSizeGuide.region.USandCA',
    sizes: [4, 6, 8, 10, 12],
    measurementSystem: MeasurementSystem.imperial.id,
  },
];
